<template>
  <div>
    <!--    <a-row>-->
    <!--      <div class="search-bar">-->
    <!--        <a-input class="mr-10" placeholder="项目编号" v-model="searchModel.ebelp"/>-->
    <!--        <a-button class="mr-10" type="primary" @click="initData">查询</a-button>-->
    <!--        <a-button class="mr-10" @click="clearSearch">重置</a-button>-->
    <!--      </div>-->
    <!--    </a-row>-->
    <a-row>
      <a-table
        id="tableDataTabs"
        bordered
        :pagination="false"
        :columns="tableData.columns"
        :rowKey="record => record.ebelp"
        :dataSource="tableData.data"
        :loading="tableData.loading"
      >
      </a-table>
    </a-row>

  </div>
</template>

<script>
import { getAssetEngineeringDetail } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    'model.ebeln': {
      handler (val) {
        console.log('触发', val)
        this.clear()
        this.initData()
      },
      immediate: true
    }
  },
  data () {
    return {
      searchModel: {
        ebelp: ''
      },
      tableData: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 50
          },
          {
            title: '采购订单号',
            dataIndex: 'ebeln',
            align: 'center'
          },
          {
            title: '项目编号',
            dataIndex: 'ebelp',
            align: 'center'
          },
          {
            title: '采购订单金额（含税）',
            dataIndex: 'netwr',
            align: 'center'
          },
          {
            title: '订单创建日期',
            dataIndex: 'aedat',
            align: 'center'
          },
          {
            title: '入账金额（净价）',
            dataIndex: 'wrbtr',
            align: 'center'
          },
          {
            title: '入账日期',
            dataIndex: 'budatFi',
            align: 'center'
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          showQuickJumper: true
        },
        loading: false
      }
    }
  },
  methods: {
    async initData () {
      this.tableData.loading = true
      const { current, pageSize } = this.tableData.pagination
      const params = { ...this.searchModel, pageNum: current, pageSize, ebeln: this.model.ebeln, ebelp: this.model.ebelp }
      const res = await getAssetEngineeringDetail(params)
      if (res && res.status === 0) {
        this.tableData.data = res.data.list
        this.tableData.pagination.total = res.data.total
      } else {
        this.$message.error(res.info.message)
      }
      this.tableData.loading = false
    },
    handleTableChange (pagination) {
      this.tableData.pagination.pageSize = pagination.pageSize
      this.tableData.pagination.current = pagination.current
      this.initData()
    },
    clear () {
      this.searchModel.ebelp = ''
      this.tableData.data = []
      this.tableData.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      }
    },
    clearSearch () {
      this.searchModel.ebelp = ''
      this.initData()
    }
  }
}
</script>

<style lang="less" scoped>
///deep/ .ant-table-thead{
//  height: 32px;
//  & th{
//    background: #E6ECF5;
//  }
//}
.table /deep/ .ant-table-thead > tr > th {
  background: #E7F4FF !important;
  //padding: 10px !important;
}
.search-bar{
  float: right;
  display: flex;
  margin: 15px 0;
}
.mr-10{
  margin-right: 10px;
}
.mb-10{
  margin-bottom: 10px;
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
